import {
  AlertCircle,
  Bot,
  DollarSign,
  Folder,
  MessageSquare,
  Notebook,
  Package,
} from "lucide-react";

// The canonical nav iconography (see ManifoldNextGenNavPicker): projects are a
// notebook, datasets a folder, agents a bot, conversations a message, and the
// project tabs' artifacts a package and costs a dollar sign. Keyed by
// singular or plural label so both ResourceLoadError and ListLoadError share it.
const RESOURCE_ICONS: Record<string, typeof Notebook> = {
  project: Notebook,
  agent: Bot,
  dataset: Folder,
  conversation: MessageSquare,
  artifact: Package,
  cost: DollarSign,
};

/**
 * The icon for a resource type, so every surface carries the same iconography
 * as the rest of nextgen. Falls back to a generic alert for unrecognized
 * labels.
 *
 * Args:
 *   resourceLabel: The resource type, singular or plural.
 *   className: Sizing for the glyph. Defaults to the load-error size.
 */
export const resourceIcon = (resourceLabel: string, className = "size-8") => {
  const Icon = RESOURCE_ICONS[resourceLabel.replace(/s$/, "")] ?? AlertCircle;
  return <Icon className={className} aria-hidden="true" />;
};
